import React, { useEffect, useState } from "react";
import AddNewFee from "../AddNewFee.component";
import FeeAddedCard from "../FeeAddedCard.component";
import PlusIconYellow from "../../../../../../assets/Icons/Universal/PlusWithYellowBack.svg";
import SecondModal from "../../../../../Universal/SecondModal.component";
const SubscriptionBasedMainScreen = () => {
  const [editModal, setEditModal] = useState(false);

  const [addFeeDetails, setAddFeeDetails] = useState([]);
  const [editModalData, setEditModalData] = useState(null);

  const [openAddForm, setOpenAddForm] = useState(false);

  const handelAddData = (data) => {
    setAddFeeDetails((prev) => [...prev, data]);
    setOpenAddForm(false);
  };
  useEffect(() => {
    !addFeeDetails.length > 0 && setOpenAddForm(true);
  }, [addFeeDetails]);
  const handelEditModalData = (index) => {
    setEditModalData(addFeeDetails[index]);
    console.log(addFeeDetails[index]);
    setEditModal(true);
  };

  const handelEditModalOutputData = (data) => {
    console.log(data);
  };
  return (
    <div className="w-full flex-row align-left justify-start scroll-x">
      <SecondModal isOpen={editModal} isCrossBtn onClose={setEditModal}>
        <div
          className="flex-col align-start justify-start scroll-y"
          style={{ height: "80vh" }}
        >
          <AddNewFee
            formType={"monthly"}
            formTitle={"Subscription fees (monthly/semester)"}
            outputData={(data) => handelEditModalOutputData(data)}
            isModal
            data={{ ...editModalData }}
          />
        </div>
      </SecondModal>
      <div className="flex-row align-left justify-start g-1 w-fit">
        {addFeeDetails &&
          addFeeDetails?.map((data, index) => {
            return (
              <FeeAddedCard
                dataType="monthly"
                lightBackColor="var(--yellowBorder)"
                deepBackColor="var(--yellowFolderColor)"
                color="var(--yellowFolderColor)"
                data={data}
                onEdit={() => handelEditModalData(index)}
              />
            );
          })}
        {openAddForm && (
          <AddNewFee
            formType={"monthly"}
            formTitle={"Subscription fees (monthly/semester)"}
            outputData={(data) => handelAddData(data)}
          />
        )}

        {!openAddForm && (
          <button
            type="button"
            onClick={() => setOpenAddForm(true)}
            className="ml-1 w-fit transparentBtn flex-row align-center jsutify-start g-05"
          >
            <img
              src={PlusIconYellow}
              alt=""
              style={{ width: "1.5rem", height: "1.5rem" }}
            />
            <span className="poppins t-14">
              <b>Add another</b>
            </span>
          </button>
        )}
      </div>
    </div>
  );
};

export default SubscriptionBasedMainScreen;
